import { render, staticRenderFns } from "./QualityInspectionTemplate.vue?vue&type=template&id=070343eb&scoped=true&"
import script from "./QualityInspectionTemplate.vue?vue&type=script&lang=ts&"
export * from "./QualityInspectionTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./QualityInspectionTemplate.vue?vue&type=style&index=0&id=070343eb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070343eb",
  null
  
)

export default component.exports